import { ValidationErrors } from 'final-form';
import * as yup from 'yup';
import { UploadMultipleFilesOutput } from '../../../../../../../../../../hooks/useMultipleFileUploads';
import LangEnum from '../../../../../../../../../../lang/LangEnum';
import yupValidation from '../../../../../../../../../../lib/yupValidation';
import {
  FileUrlAndName,
  ImageOrVideoType,
  ImageOrVideoUrlNameAndTypes,
} from '../../../../../../../../contexts/chatSocket/hooks/useChatWebsocket/useChatWebsocket.types';
import { MessageType } from '../../../../../../../../types/chat.types';
import { MESSAGE_IMAGE_OR_VIDEO_ACCEPTED_TYPES } from '../../../../../../contexts/chatMessages.context.utilts';

interface GroupedFilesByMessageType {
  [MessageType.FILE]: FileUrlAndName[];
  [MessageType.IMAGE_OR_VIDEO]: ImageOrVideoUrlNameAndTypes[];
}

const messageValidate = yup.object().shape({
  messageText: yup.string().trim().required(LangEnum.GLOBAL_REQUIRED),
});

export const messageFormValidate = async (values: {
  messageText: string;
}): Promise<ValidationErrors> => yupValidation(messageValidate)({ ...values });

export const groupUploadedFilesByMessageType = (uploadedFiles: UploadMultipleFilesOutput[]) =>
  uploadedFiles.reduce<GroupedFilesByMessageType>(
    (acc, fileData) => {
      const { url, file } = fileData;
      if (!url) {
        return acc;
      }

      const imageOrVideoTypesToValidate = MESSAGE_IMAGE_OR_VIDEO_ACCEPTED_TYPES.map((type) =>
        type.replace('.', ''),
      );

      const type = imageOrVideoTypesToValidate.some((fileType) => file.type.includes(fileType))
        ? MessageType.IMAGE_OR_VIDEO
        : MessageType.FILE;

      if (type === MessageType.IMAGE_OR_VIDEO) {
        acc[type].push({
          url,
          name: file.name,
          type: file.type.includes('image') ? ImageOrVideoType.IMAGE : ImageOrVideoType.VIDEO,
        });
      } else {
        acc[type].push({ url, name: file.name });
      }

      return acc;
    },
    { [MessageType.FILE]: [], [MessageType.IMAGE_OR_VIDEO]: [] },
  );
